import { Component, Input } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { HttpService } from './../../services/http/http.service';

@Component({
    selector: 'svg-render-external',
    templateUrl: 'svg-render-external.component.html',
    styleUrls: ['svg-render-external.component.scss'],
})
export class SvgRenderExternalComponent {

    @Input() public svgUrl: string;

    constructor(
        private http: HttpService,
    ) { }

    public ngOnInit() {
        const headers = new Headers();
        headers.append('Access-Control-Allow-Origin', '*');
        const options = new RequestOptions({ headers });

        this.http.get(this.svgUrl)
            .subscribe((data) => {
                // console.log(data);
            });
    }
}
